import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=89db7dde&scoped=true&"
import script from "./Terms.vue?vue&type=script&setup=true&lang=js&"
export * from "./Terms.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=89db7dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89db7dde",
  null
  
)

export default component.exports